<div class="dam-element">
  <label *ngIf="write"
         i18n="@@ClickOrDragDocument"
         for="document-uploader-input"
         class="well my-drop-zone"
         ng2FileDrop
         [ngClass]="{'file-over': true}"
         (fileOver)="fileOver($event)"
         (onFileDrop)="upload()"
         [uploader]="uploader"
  >
    Кликните или перетащите сюда версию документа
  </label>
  <input
    type="file"
    ng2FileSelect
    (change)="upload()"
    [uploader]="uploader"
    multiple
    id="document-uploader-input"
    style="display:none"
  />

  <div class="section" *ngIf="damItem">
    <a (click)="show(actions, damItem.id)" class="download-link" target="_blank">
      <app-secured-image
        *ngIf="showThumbnail(damItem?.mimeType)"
        src="/dam/get-image-dynamic-version/{{damItem.id}}/800/true"
      ></app-secured-image>
      <img *ngIf="!showThumbnail(damItem?.mimeType)"
           style="height: 300px;"
           class="vivid" src="/assets/images/dam/vivid/{{getExtension(damItem)}}.svg"
           alt="">
    </a>
    <div class="flex f-wrap g-12">
			<span class="w-100 clr-black-base fw-600 fs-14">
          {{ damItem?.header }}
			</span>
      <span class="clr-black-sec fw-500 fs-12">
				ID {{ damItem?.documentId }}
			</span>
      <span class="clr-black-sec fw-500 fs-12">
        <span i18n="@@Updated">Изменено</span>: {{ (damItem?.updatedAt || damItem?.createdAt) | date: 'dd.MM.yyyy hh:mm' }}
			</span>
      <!--      <span class="clr-black-sec fw-500 fs-12">-->
      <!--        <span i18n="@@Approved">Подтверждено</span>: {{damItem?.documentId}}-->
      <!--			</span>-->
    </div>
  </div>
</div>

<ng-template
  #actions
  let-content="content"
>
  <a
    download
    size="s"
    tuiButton
    [href]="content"
    i18n="@@Download"
  >
    Скачать
  </a>
</ng-template>

